import Image from 'next/legacy/image';
import Link from 'next/link';

import styles from './PressBox.module.css';

const HorizontalPressBox = ({item}) => {
  return (
    <Link href={item.link} passHref legacyBehavior>
      <div className={styles.app__horizontal_box}>
        <div className={styles.app__horizontal_box_image_wrapper}>
          <Image
            src={item.imgUrl}
            alt={item.title}
            layout="fill"
            objectFit="contain"
          />
        </div>
        <div className={styles.app__horizontal_box_right}>
          <p>{item.time}</p>
          <span>{item.title}</span>
        </div>
      </div>
    </Link>
  );
};

export default HorizontalPressBox;
